module.exports = __webpack_public_path__ + "2a1d9da2fcc4c24574d471016d653824.jpg";